import { render, staticRenderFns } from "./SpecialCourseScheduleCalendar.vue?vue&type=template&id=23ffa0f1&scoped=true"
import script from "./SpecialCourseScheduleCalendar.vue?vue&type=script&lang=js"
export * from "./SpecialCourseScheduleCalendar.vue?vue&type=script&lang=js"
import style0 from "./SpecialCourseScheduleCalendar.vue?vue&type=style&index=0&id=23ffa0f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ffa0f1",
  null
  
)

export default component.exports